import { createFileRoute, redirect } from '@tanstack/react-router';

// The API, the connector and the docs link here; kept for good.
export const Route = createFileRoute('/account/billing')({
  beforeLoad: ({ location }) => {
    throw redirect({ to: '/settings/billing', search: location.search, hash: location.hash || undefined });
  },
});
